import { loadRemoteModule } from "@cw-elements/mfe-setup/load";
import React from "react";
import { Layout } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useConfig, type CWElementsConfig } from "@cw-elements/config";
import { RoutePaths, history } from "core/history";
import { useSelector } from "react-redux";
import { getCurrentWorkspace, getDefaultWorkspace } from "app-redux/selectors/licensingAccounts.selector";
import { getCurrentUser } from "app-redux/selectors/accounts.selector";

export interface InviteMembersProps {
  getConfigInstance: () => CWElementsConfig;
  workspaceId: string;
  onCancel: () => void;

  memberId?: string;
}
const InviteMembers = React.lazy(() =>
  loadRemoteModule<InviteMembersProps>("invite-members/index")
);

export function InviteMembersPage() {
  const params = new URLSearchParams(location.search)
  const workspaceId = params.get('workspace')
  const memberId = params.get('member')

  return workspaceId ? (
    <Layout.Content>
      <React.Suspense
        fallback={
          <div style={{ margin: 12 }}>
            <LoadingOutlined />
          </div>
        }
      >
        <InviteMembers 
          getConfigInstance={useConfig}
          workspaceId={workspaceId}
          memberId={memberId || undefined}
          onCancel={() => {
            history.push(RoutePaths.WORKSPACES(workspaceId));
          }}
        />
      </React.Suspense>
    </Layout.Content>
  ) : null
}
